/* import __COLOCATED_TEMPLATE__ from './sq-image.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _class2, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { classNames, attributeBindings, tagName } from '@ember-decorators/component';
import { computed, set } from '@ember/object';
import { on } from '@ember-decorators/object';
import { alias } from '@ember/object/computed';
import Component from '@ember/component';
import { htmlSafe } from '@ember/template';
import { getFastlyUrl, IMAGE_ORIGIN_TO_FASTLY_MAPPING } from '@square/dashboard-utilities/utils/fastly-image-optimizer';
import { inject as service } from '@ember/service';

/**
`SqImageComponent` is flexible component for rendering images.

If the domain of the image is mapped in the `IMAGE_ORIGIN_TO_FASTLY_MAPPING`
constant in the `fastly-image-optimizer` util, fastly image optimization will
be used.

By default, it assumes you want the image url to be used as a background image
within an `i` tag. If you'd like to use an `img` tag instead, you can change
the `tagName` to 'img' and it should just work. You can prevent `width` and
`height` styles from being added to the element by setting
`includeDimensionsStyle` to false.

## Simple Example

You can use an `{{#sq-image}}` to easily display an image. Pass in the url,
width, and height (in pixels). Pass in the `class` for extra styling.

```handlebars
{{sq-image url="squareup.com/square.png"
           width="200"
           height="200"
           class="logo"}}
```

You can also use bindings for extra fun.

```handlebars
{{sq-image url=image.url
           width=thumbnailWidth
           height=thumbnailHeight
           class="image-gallery-thumbnail"}}
```
*/

const DATA_URL_REGEX = /data:(.*);base64/;
let SqImage = (_dec = tagName('i'), _dec2 = classNames('image'), _dec3 = attributeBindings('style'), _dec4 = alias('imageUrl'), _dec5 = on('init'), _dec6 = computed('fastlyFit', 'height', 'url', 'renderSizeRatio', 'width'), _dec7 = computed('width', 'height', 'includeDimensionsStyle'), _dec8 = computed('imageUrl', 'dimensionsStyle'), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = class SqImage extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "url", null);
    _defineProperty(this, "width", null);
    _defineProperty(this, "height", null);
    _defineProperty(this, "renderSizeRatio", 1);
    _defineProperty(this, "fastlyFit", null);
    _defineProperty(this, "includeDimensionsStyle", true);
    _initializerDefineProperty(this, "assetMap", _descriptor, this);
    _initializerDefineProperty(this, "src", _descriptor2, this);
  }
  setupAttributes() {
    if (this.tagName === 'img') {
      set(this, 'attributeBindings', ['src', 'width', 'height']);
    }
  }
  get imageUrl() {
    const url = this.url;
    if (!url || DATA_URL_REGEX.test(url)) {
      return url;
    }
    let domain;
    try {
      domain = new URL(url).hostname;
    } catch {
      domain = null;
    }
    if (domain && IMAGE_ORIGIN_TO_FASTLY_MAPPING[domain]) {
      return getFastlyUrl(url, {
        width: this.width * this.renderSizeRatio,
        height: this.height * this.renderSizeRatio,
        fit: this.fastlyFit
      });
    }
    return url;
  }
  get dimensionsStyle() {
    const {
      width,
      height,
      includeDimensionsStyle
    } = this;
    if (width && height && includeDimensionsStyle) {
      return `width: ${width}px; height: ${height}px;`;
    } else {
      return '';
    }
  }
  get style() {
    const imageUrl = this.imageUrl;
    if (imageUrl) {
      const resolvedImage = this.assetMap.resolve(imageUrl);
      return htmlSafe(`background-image: url("${resolvedImage}"); ${this.dimensionsStyle}`);
    } else {
      return htmlSafe(this.dimensionsStyle);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "assetMap", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "src", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "setupAttributes", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "setupAttributes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "imageUrl", [_dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "imageUrl"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "dimensionsStyle", [_dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "dimensionsStyle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "style", [_dec8], Object.getOwnPropertyDescriptor(_class2.prototype, "style"), _class2.prototype), _class2)) || _class) || _class) || _class);
export { SqImage as default };